import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';

export default class RequestBooking extends React.Component {
  static displayName = 'TourPage-BookingDetails-RequestBooking';
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
  };
  static defaultProps = {
    loading: false,
    disabled: false,
    supportsMultiplePaymentMethods: false,
  };

  onClick(e) {
    if (!this.props.loading && !this.props.disabled) {
      this.props.onClick(e);
    }
  }

  renderMultiplePaymentMethodsHint() {
    let view = null;

    if (this.props.supportsMultiplePaymentMethods) {
      view = (
        <div className="RequestBooking-hint">Pay Now or in Cash later</div>
      );
    }
    return view;
  }

  render() {
    const { loading, disabled, label } = this.props;
    const className = classnames(
      'RequestBooking ui fluid huge button anygreen brand-bg',
      {
        loading,
        disabled,
      }
    );
    return (
      <button
        type="button"
        data-testid="submit-button"
        className={className}
        onClick={this.onClick.bind(this)}
        disabled={disabled}
        onKeyDown={(e) => isActionKey(e.key) && this.onClick.bind(this)}
        aria-label="Request for Booking"
        title="Request for booking"
      >
        {label}
        {this.renderMultiplePaymentMethodsHint()}
      </button>
    );
  }
}
